import { render, staticRenderFns } from "./AppPotwierdzenieOK.vue?vue&type=template&id=36e28fcc&"
import script from "./AppPotwierdzenieOK.vue?vue&type=script&lang=js&"
export * from "./AppPotwierdzenieOK.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports